import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "progress-container"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 0,
    class: "personalDetails"
};
const _hoisted_4 = {
    key: 0,
    class: "well"
};
const _hoisted_5 = { class: "submitControls" };
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useCredit } from '@/composables/useCredit';
import { useMortgage } from '@/composables/useMortgage';
import { useContent } from '@/composables/useContent';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import InputSections from './elements/InputSections.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddMortgagePage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getCreditProviders } = useCredit();
        const { getMortgage, getMortgageInfo, addMortgageAccount, updateMortgageAccount } = useMortgage();
        const { getAiopSection } = useContent();
        const validationText = ref(null);
        const sectionNo = ref(0);
        const currentPageNumber = ref(0);
        const sections = ref([]);
        const policy = ref(null);
        const breadCrumb = ref([]);
        const inputSections = ref(null);
        const mortgageHeader = computed(() => {
            const verb = route.params.id ? 'Edit' : 'Add';
            if (!sections.value || !sections.value[0] || !sections.value[0].fields || !sections.value[0].fields[0] || !sections.value[0].fields[0].value) {
                return verb + " mortgage details";
            }
            return verb + " " + sections.value[0].fields[0].value + " Mortgage details";
        });
        const progressValue = computed(() => {
            const insuranceType = findFieldValue('Type');
            const totalPages = sectionsAvailableCount(insuranceType);
            if (totalPages === 0)
                return 0;
            return ((currentPageNumber.value + 1) / totalPages) * 100;
        });
        // --- Helper functions (from Helpers mixin) ---
        function findFieldValue(fieldName) {
            for (const section of sections.value) {
                for (const field of section.fields) {
                    if (field.label === fieldName && field.value != null) {
                        return field.value;
                    }
                }
            }
            return null;
        }
        function findField(fieldName) {
            for (const section of sections.value) {
                for (const field of section.fields) {
                    if (field.label === fieldName) {
                        return field;
                    }
                }
            }
            return null;
        }
        function loadFieldsFromObject(fieldMappings) {
            Object.keys(fieldMappings).forEach(fieldName => {
                sections.value.forEach(section => {
                    section.fields.forEach((field) => {
                        if (field.label === fieldName) {
                            field.value = fieldMappings[fieldName];
                        }
                    });
                });
            });
        }
        function removeNullProperties(obj) {
            Object.keys(obj).forEach(key => obj[key] == null && delete obj[key]);
            return obj;
        }
        function dateToString(dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${day}/${month}/${year}`;
        }
        function stringToDate(dateString) {
            if (!dateString || dateString === 'NaN/NaN/NaN') {
                return null;
            }
            const [day, month, year] = dateString.split('/');
            return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        }
        function sectionAllowed(section) {
            if (!section.rule)
                return true;
            const [ruleKey, ruleValue] = section.rule.split(':').map((s) => s.trim());
            const ruleValues = ruleValue.split(',').map((s) => s.trim());
            for (let i = 0; i < sectionNo.value; i++) {
                const sec = sections.value[i];
                for (const field of sec.fields) {
                    if (field.id === ruleKey && ruleValues.includes(field.value)) {
                        return true;
                    }
                }
            }
            return false;
        }
        function inputControlGoNext(onFinished = null, before = null) {
            validationText.value = '';
            let allOK = true;
            if (before) {
                if (!before())
                    return;
            }
            for (const field of sections.value[sectionNo.value].fields) {
                if (field.required && (!field.value || field.value === "")) {
                    validationText.value = field.validationText;
                    allOK = false;
                    break;
                }
                if (field.type === 'datetext' && field.value.length < 10) {
                    validationText.value = "Please enter date in the format dd/mm/yyyy";
                    allOK = false;
                    break;
                }
                if (field.strongPass != undefined && field.strongPass == false) {
                    validationText.value = "Your password is not strong enough";
                    allOK = false;
                    break;
                }
            }
            if (allOK) {
                let allowed = false;
                breadCrumb.value.push({ sectionNo: sectionNo.value });
                while (!allowed) {
                    validationText.value = null;
                    sectionNo.value++;
                    if (!sections.value[sectionNo.value]) {
                        if (onFinished) {
                            onFinished();
                            return;
                        }
                    }
                    else {
                        allowed = sectionAllowed(sections.value[sectionNo.value]);
                    }
                }
                currentPageNumber.value++;
                inputSections.value.next(sectionNo.value);
            }
            setTimeout(() => { validationText.value = null; }, 4000);
        }
        function inputControlGoBack() {
            const crumb = breadCrumb.value.pop();
            sectionNo.value = crumb.sectionNo;
            validationText.value = null;
            currentPageNumber.value--;
            inputSections.value.back(sectionNo.value);
        }
        function preValidate() {
            validationText.value = null;
            const now = new Date();
            sections.value[sectionNo.value].fields.forEach((field) => {
                if (field.type === 'datetext' && field.value) {
                    const [day, month, year] = field.value.split('/');
                    const date = new Date(year, month - 1, day);
                    if (field.future && date < now) {
                        validationText.value = `${field.label} must be in the future`;
                        return false;
                    }
                    if (field.past && date > now) {
                        validationText.value = `${field.label} must be in the past`;
                        return false;
                    }
                }
            });
            return !validationText.value;
        }
        // --- Page-specific methods ---
        function populateFields() {
            const fieldMappings = {
                'Ownership': policy.value.account.jointStatus === 2 ? 'Joint' : 'Sole',
                'Provider': policy.value.account.provider.name,
                'Account number': policy.value.account.reference,
                'Balance': policy.value.account.balances[policy.value.account.balances.length - 1].amount,
                'Monthly Repayment': policy.value.monthlyRepaymentAmount,
                'Date opened': dateToString(policy.value.account.creditCreateDate),
                'Term (Years)': policy.value.account.termMonths / 12,
                'Type': policy.value.interestRateType === 0 ? 'Fixed' : policy.value.interestRateType === 1 ? 'Standard Variable' : policy.value.interestRateType === 2 ? 'Discount Tracker' : null,
                'Deal end date': dateToString(policy.value.dealEndDate),
                'Deal rate': policy.value.dealRate,
                'Interest rate when deal ends': policy.value.rate,
                'Interest rate': policy.value.rate,
                'Address': policy.value.address
            };
            loadFieldsFromObject(fieldMappings);
        }
        function addMortgage() {
            const creditType = { name: findFieldValue('Type') || null };
            const provider = { name: findFieldValue('Provider') || null };
            const balance = { amount: findFieldValue('Balance') || null };
            const balances = [balance];
            const addressObject = findFieldValue('Address') || null;
            const addressInsured = {
                line1: addressObject?.line1 || null,
                line2: addressObject?.line2 || null,
                line3: addressObject?.line3 || null,
                town: addressObject?.town || null,
                postCode: addressObject?.postCode || null,
            };
            const creditAccount = {
                address: addressInsured,
                account: {
                    provider: provider,
                    creditType: creditType,
                    reference: findFieldValue('Account number') || null,
                    balances: balances,
                    balance: balance,
                    creditCreateDate: stringToDate(findFieldValue('Date opened')) || null,
                    termMonths: findFieldValue('Term (Years)') * 12 || null,
                    jointStatus: findFieldValue('Ownership') === 'Joint' ? 2 : findFieldValue('Ownership') === 'Sole' ? 1 : null,
                },
                monthlyRepaymentAmount: findFieldValue('Monthly Repayment') || null,
                dealEndDate: stringToDate(findFieldValue('Deal end date')) || null,
                dealRate: findFieldValue('Deal rate') || null,
                rate: findFieldValue('Interest rate when deal ends') || findFieldValue('Interest rate') || null,
                interestRateType: findFieldValue('Type') === 'Fixed' ? 0 : findFieldValue('Type') === 'Standard Variable' ? 1 : findFieldValue('Type') === 'Discount Tracker' ? 2 : null,
                termMonths: findFieldValue('Term') || null,
                creditCreateDate: stringToDate(findFieldValue('Start date')) || null,
            };
            if (route.params.id) {
                creditAccount.id = route.params.id;
            }
            removeNullProperties(creditAccount);
            const handleResponse = (res) => {
                if (res) {
                    if (route.params.id) {
                        getMortgage(route.params.id, null, true);
                    }
                    getMortgageInfo(null, true);
                    router.push({ path: '/policysuccess', query: { type: 'mortgage' } });
                }
            };
            if (!route.params.id) {
                addMortgageAccount(creditAccount, handleResponse);
            }
            else {
                updateMortgageAccount(creditAccount, handleResponse);
            }
        }
        function sectionsAvailableCount(insuranceType) {
            const sectionsNoRule = sections.value.filter(section => !section.rule);
            const sectionsMatchingRule = sections.value.filter(section => section.rule && section.rule.includes(insuranceType));
            return sectionsNoRule.length + sectionsMatchingRule.length;
        }
        function onLoad() {
            getAiopSection('AddMortgagePageSections.json', () => {
                sections.value = state.sectionJson;
                if (route.params.id) {
                    getMortgage(route.params.id, (p) => {
                        policy.value = p;
                        populateFields();
                    });
                }
                getCustomer();
                getCreditProviders((res) => {
                    res = res.filter((item) => item.mortgage === true)
                        .filter((item, index, self) => index === self.findIndex((t) => t.name === item.name));
                    const providerField = findField('Provider');
                    if (providerField) {
                        providerField.showAvatars = true;
                        providerField.items = res.map((x) => {
                            return x.name.replace(/\w\S*/g, (txt) => {
                                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                            });
                        });
                    }
                });
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_progress_linear = _resolveComponent("v-progress-linear");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: mortgageHeader.value,
                    bgcolor: "white",
                    border: "0"
                }, null, 8, ["title"]),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer && _unref(state).creditProviders
                }, null, 8, ["customer"]),
                (sections.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_v_progress_linear, {
                            "model-value": progressValue.value,
                            rounded: ""
                        }, null, 8, ["model-value"])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer && _unref(state).creditProviders && (policy.value || !_unref(route).params.id))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (sections.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createVNode(InputSections, {
                                            ref_key: "inputSections",
                                            ref: inputSections,
                                            sections: sections.value,
                                            theme: "light"
                                        }, null, 8, ["sections"]),
                                        (validationText.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                _createElementVNode("p", null, _toDisplayString(validationText.value), 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_5, [
                                            _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                    (currentPageNumber.value > 0)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 0,
                                                            cols: "5"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(MGButton, {
                                                                    small: "true",
                                                                    outline: true,
                                                                    onClick: _cache[0] || (_cache[0] = ($event) => (inputControlGoBack())),
                                                                    text: "Back"
                                                                })
                                                            ]),
                                                            _: 1
                                                        }))
                                                        : _createCommentVNode("", true),
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(MGButton, {
                                                                small: currentPageNumber.value > 0,
                                                                alt: true,
                                                                text: "Next",
                                                                arrow: true,
                                                                onClick: _cache[1] || (_cache[1] = ($event) => (inputControlGoNext(addMortgage, preValidate)))
                                                            }, null, 8, ["small"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
